import type { tableWidgetCell } from "@/elements/table/tableCell";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

export class WmMerge extends wmBase {
    constructor(options: widgetOption<tableWidgetCell>[]) {
        super();
        this.options = options;
    }

    build() {
        return `
            <div class="wm_merge">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <rect y="2" width="2" height="18" rx="1" transform="rotate(-90 0 2)" fill="black"/>
                    <rect y="18" width="2" height="18" rx="1" transform="rotate(-90 0 18)" fill="black"/>
                    <rect x="8" width="2" height="6" rx="1" fill="black"/>
                    <rect x="8" y="12" width="2" height="6" rx="1" fill="black"/>
                    <path d="M1 9H7M7 9L4.66667 11.625M7 9L4.66667 6.375" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M17 9L11 9M11 9L13.3333 6.375M11 9L13.3333 11.625" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        `;
    }

    init() {
        const item = document.querySelector(".wm_merge");
        item?.removeEventListener("click", this.itemClick, false);
        item?.addEventListener("click", this.itemClick, false);
    }

    itemClick = (e: Event) => {
        this.applyValue(this.options, this.options, false, false);
    };

    options: widgetOption<tableWidgetCell>[] = [];
}
